export const state = () => ({
    list: {},
    mainCategories: [],
    categoryFacetsLoaded: false,
    categoryPageBannerAvailable: false,
    categoryInDrawer: '',
    categoryInDrawerStorefront: '',
    categoryBannersInMenu: {},
    generalFiltersCounts: {
        new_brands: 0,
        new_products: 0,
        with_discounts: 0,
        bestsellers: 0,
        is_active_tica: 0,
    },
})

export const getters = {
    categoriesReady(state) {
        return Object.keys(state.list).length
    },
    hasAnyCategoryBanner(state) {
        return state.categoryPageBannerAvailable
    },
    flatList(state) {
        return Object.keys(state.list).map((key) => state.list[key])
    },
    categoriesListByPath(state) {
        return state.list
    },
}

export const mutations = {
    /**
     * Updates the state with the initial flattened and filtered window.Store.marketplace.categories
     *
     * @param {object} state
     * @param {object} categoriesObject
     */
    updateCategoriesList(state, categoriesObject) {
        state.list = categoriesObject
    },
    /**
     * Updates the main categories list
     *
     * @param {object} state
     * @param {object} categoriesObject
     */
    updateMainCategoriesList(state, categoriesObject) {
        state.mainCategories.push(categoriesObject)
    },
    /**
     * Updates the storefront categories list
     *
     * @param {object} state
     * @param {object} categoriesObject
     */
    updateCategoriesListCounts(state, categoriesObject) {
        const listWithCounts = { ...state.list }

        Object.keys(state.list).forEach((category) => {
            listWithCounts[category] = {
                ...state.list[category],
                facetCount: categoriesObject[category],
            }
        })

        state.categoryFacetsLoaded = true
        state.list = listWithCounts
    },
    updateCategoryImagesFromPrismic(state, imagesPayload) {
        state.images = imagesPayload
    },
    updateCategoryPageBanner(state, payload) {
        state.categoryPageBannerAvailable = payload
    },
    updateGeneralFiltersCounts(state, filtersPayload) {
        state.generalFiltersCounts = filtersPayload
    },
    updateCategoryInDrawer(state, payload) {
        if (payload.location === 'storefront') {
            state.categoryInDrawerStorefront = payload.categoryPath
        } else {
            state.categoryInDrawer = payload.categoryPath
        }
    },
    updateCategoryMenuBannerFromPrismic(state, payload) {
        const bannerList = {}

        payload.category.forEach((item) => {
            bannerList[item.category_slug] = { ...item }
        })

        state.categoryBannersInMenu = bannerList
    },
}

export const actions = {
    /**
     * Takes in window.Store.categories and flattens it into a path based object.
     * Recursively fires a function to build the list and at the end commits the entire object to state
     * Deep copy is used to remove unneeded nestings that will burden the RAM.
     *
     * @param {object} context
     * @param {Array} payload
     */
    flattenCategoriesToPathObject(context, payload) {
        const categories = {}

        const addCategoryToList = (categoryPayload) => {
            const category = { ...categoryPayload }
            category.childrenCount = category.children?.length || 0
            category.displayedName = category.translation?.name || category.name

            categories[category.path] = category

            if (category.depth === 0) {
                // if main category, commit to separate list for ease of use
                const deepCopy = JSON.parse(JSON.stringify(category))
                delete deepCopy.children
                context.commit('updateMainCategoriesList', deepCopy)
            }

            if (category.children) {
                category.children.forEach(addCategoryToList)
            }
        }

        payload.forEach(addCategoryToList)

        context.commit('updateCategoriesList', categories)
    },
}
